// extracted by mini-css-extract-plugin
export default {"header":"header_header__tARUV"};